import React from 'react'
import { Footer } from '../footer/Footer'

const AuthFooter = () => <Footer />

export default AuthFooter
